import { Table, Box, Avatar, Typography, InputLabel } from "@mui/material";
import React from "react";
import { StyledTableCell, StyledTableRow } from "../../Common/StyledCell";
import EmptyData from "../../Common/EmptyData";

const Product = ({ data = [] }) => {

  console.log(data)
  return (
    <>
      <Table>
        {!data || data?.length === 0 ? (
          <>
            <EmptyData label="No Data available currently" height="400px" />
          </>
        ) : (
          <>
            {data?.map((item, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: 2,
                      width: "70%",
                    }}
                  >
                  <div>

                   <Avatar src={item?.product?.images[0] || ""} sx={{borderRadius:'4px'}} alt="" width={30}/>
                  </div>
                    <Box>
                      <InputLabel
                        sx={{
                          fontFamily: "Lato",
                          fontWeight: 500,
                        
                        }}
                      >
                        {item?.product?.name || ""}
                      </InputLabel>
                    
                    </Box>
                  </Box>
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.totalSold} sold
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </>
        )}
      </Table>
    </>
  );
};

export default Product;
